import CustomCard from '../customs/CustomCard';
import UsageDataSheet from '../components/data/UsageDataSheet';


const DataPage = () => (
  <CustomCard style={{ margin: 20, marginTop: 0 }}>
    <UsageDataSheet />
  </CustomCard>
);


export default DataPage;
